import e from "./generateUtilityClass.mjs";
import r from "./generateUtilityClasses.mjs";
function a(t) {
  return e("MuiDatePickerToolbar", t);
}
r("MuiDatePickerToolbar", ["root", "title"]);
export {
  a as getDatePickerToolbarUtilityClass
};
//# sourceMappingURL=datePickerToolbarClasses.mjs.map
